import React from "react";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";

import { EyeOutlined } from "@ant-design/icons";
interface OrdersTableProps {
  products: any[];
  loading: boolean;
  onEditOrder: (order: any) => void;
  currentPage: number;
  pageNumbers: any[];
  currentProducts: any[];
  handlePageChange: (e: any) => void;
}

const OrdersTable: React.FC<OrdersTableProps> = ({
  products,
  loading,
  onEditOrder,
  currentPage,
  pageNumbers,
  handlePageChange,
  currentProducts,
}) => {
  const handleEditOrder = (order: any) => {
    onEditOrder(order);
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      day: "numeric",
      year: "numeric",
      month: "long",
    };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  return (
    <div className="flex flex-col text-black">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
          <div className="overflow-hidden  rounded-lg">
            <table className="min-w-full text-sm">
              <thead
                className="text-xs text-gray-700 
              dark:text-gray-400">
                <tr className="bg-gray-100 text-black text-[16px] h-[65px]">
                  <th scope="col" className="px-6 py-3">
                    Order Number
                  </th>

                  <th scope="col" className="px-6 py-3">
                    Products
                  </th>

                  <th scope="col" className="px-6 py-3">
                   Grand Total
                  </th>

                  <th scope="col" className="px-6 py-3">
                    Date ordered
                  </th>

                  <th scope="col" className="px-6 py-3">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="text-blue">
                {loading ? (
                  <tr>
                    <td colSpan={5} className="text-center py-4">
                      Loading...
                    </td>
                  </tr>
                ) : (
                  currentProducts.map((product) => (
                    <tr
                      key={product.id}
                      className="hover:bg-gray-100 transition duration-200 text-[#75A7AD]">
                   
                      <td className="order-b p-3 font-semibold text-black">
                        {product.reference_number}
                      </td>
                      <td className="border-b p-3">
                        {product.products?.map((subProduct: any) => (
                          <div
                            key={subProduct.product_id}
                            className="flex p-3 mb-1 border border-gray-300 rounded-md transition duration-150 w-full">
                            <span className="font-medium text-gray-800 w-1/2">
                              {subProduct.name}
                            </span>
                            <span className="font-bold text-gray-900 w-1/2 text-right">
                              {subProduct.quantity}
                            </span>
                          </div>
                        ))}
                      </td>

                      <td className="border-b p-3">{product.grand_total}</td>

                      <td className="border-b p-3">
                        {formatDate(product.requested_ship_date)}
                      </td>

                      <td className="border-b p-3">
                        <div className="flex items-center space-x-4">
                          <span
                            onClick={() => handleEditOrder(product)}
                            className="text-[#75A7AD] cursor-pointer hover:text-gray-800 flex items-center"
                            title="View Order">
                            <EyeOutlined className="mr-1" size={30} />
                            View
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="flex space-x-4 mt-[20px] justify-end">
        <section className=" inline-flex col row">
          <div className="flex">
            {currentPage > 1 && (
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                className="rounded-full h-8 px-1 font-semibol bg-white  ml-[10px]">
                <BiChevronLeft size={30} className="text-black" />
              </button>
            )}

            {pageNumbers.map(
              (number, index) =>
               
                currentPage <= index + 2 &&
                index + 1 <= currentPage + 2 && (
                  <div className="flex space-x-3" key={number}>
                    {<div></div>}
                    <button
                      className="rounded-full h-8 px-3 font-semibol text-white "
                      onClick={() => handlePageChange(number)}
                      style={{
                        backgroundColor:
                          number === currentPage ? "#75A7AD" : "white",
                        color: number === currentPage ? "white" : "black",
                      }}>
                      {number}
                    </button>
                  </div>
                )
            )}

            {currentPage < pageNumbers.length && (
              <button
                className="rounded-full h-8 px-1 font-semibol bg-white  ml-[10px]"
                onClick={() => handlePageChange(currentPage + 1)}>
                <BiChevronRight size={30} className="text-black " />
              </button>
            )}
          </div>
        </section>
        <section className=" flex space-x-8  p-2">
          <h5 className="font-bold text-black text-xs mr-[-20px]">
            Product per page
          </h5>
          <select
            id="role"
            className="mt-[-8px] w-[90px] py-2  block rounded-md focus:outline-none text-black text-sm bg-white"
            name="role"
            value={currentPage}
            onChange={(e) => handlePageChange(Number(e.target.value))}>
            {pageNumbers.map((option: number) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </section>
      </div>
    </div>
  );
};

export default OrdersTable;

// import React from "react";
// import { FaEdit } from "react-icons/fa";

// interface OrdersTableProps {
//   orders: any[];
//   loading: boolean;
//   onEditOrder: (order: any) => void;
// }

// const OrdersTable: React.FC<OrdersTableProps> = ({
//   orders,
//   loading,
//   onEditOrder,
// }) => {
//   const handleEditOrder = (order: any) => {
//     onEditOrder(order);
//   };

//   return (
//     <div className="flex flex-col text-black">
//       <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
//         <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
//           <div className="overflow-hidden  rounded-lg ">
//             <table className="min-w-full text-sm">
//               <thead className="text-xs text-gray-700 uppercase dark:text-gray-400">
//                 <tr className="bg-[#75A7AD] text-white text-[16px] h-[65px]">
//                   <th scope="col" className="px-6 py-3">
//                     Order Reference
//                   </th>
//                   <th scope="col" className="px-6 py-3">
//                     Products
//                   </th>
// <th scope="col" className="px-6 py-3">
//   Quote Status
// </th>
//                   <th scope="col" className="px-6 py-3">
//                     Date Ordered
//                   </th>
//                   <th scope="col" className="px-6 py-3">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="text-blue">
//                 {loading ? (
//                   <tr>
//                     <td colSpan={5} className="text-center py-4">
//                       Loading...
//                     </td>
//                   </tr>
//                 ) : (
//                   orders.map((order) => (
//                     <tr
//                       key={order.id}
//                       className="hover:bg-gray-100 transition duration-200 text-[#75A7AD]">
//                       <td className="border-b p-3 font-semibold text-black">
//                         {order.reference_number}
//                       </td>
//                       <td className="border-b p-3">
// {order.products.map((product: any) => (
//   <div
//     key={product.product_id}
//     className="flex p-3 mb-1 border border-gray-300 rounded-md
//      transition duration-150 w-full">
//     <span className="font-medium text-gray-800 w-1/2">
//       {product.name}
//     </span>
//     <span className="font-bold text-gray-900 w-1/2 text-right">
//       {product.quantity}
//     </span>
//   </div>
// ))}
//                       </td>
//                       <td className="border-b p-3">{order.quote_status}</td>
//                       <td className="border-b p-3">
//                         {order.requested_ship_date
//                           ? new Date(
//                               order.requested_ship_date
//                             ).toLocaleDateString()
//                           : "N/A"}
//                       </td>
//                       <td className="border-b p-3">
//                         <span
//                           onClick={() => handleEditOrder(order)}
//                           className="text-[#75A7AD] cursor-pointer hover:text-gray-800 flex items-center"
//                           title="Edit Order">
//                           <FaEdit className="mr-1 text-[#75A7AD]" />
//                           Edit
//                         </span>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OrdersTable;
